import {
  ContactDetailsChatTabLocation,
  ContactDetailsLocation,
  ContactDetailsNotesTabLocation,
  ContactsLocation,
  CoorporativeDashboardLocation,
  DocumentDetailsChatTabLocation,
  DocumentDetailsLocation,
  DocumentDetailsNotesTabLocation,
  DocumentsDashboardLocation,
  DocumentsLocation,
  HomeLocation,
  LeadDetailsChatTabLocation,
  LeadDetailsLocation,
  LeadDetailsNotesTabLocation,
  LeadsLocation,
  PartnersDashboardLocation,
  SimulationLocation,
} from "../../../Locations";
import { BreadcrumbItem } from "../../Breadcrumbs/components/Breadcrumb";

export const mainFrameBreadCrumbs: BreadcrumbItem[] = [
  {
    label: "Home",
    value: HomeLocation,
  },
  {
    label: "Dashboards",
    value: "",
    selectOptions: [
      {
        label: "Seguros",
        value: DocumentsDashboardLocation,
      },
      {
        label: "Parceiros",
        value: PartnersDashboardLocation,
        flag: "admin-only",
      },
      {
        label: "Corporativo",
        value: CoorporativeDashboardLocation,
        flag: "leads-view",
      },
    ],
  },
  {
    label: "Documentos",
    value: DocumentsLocation,
  },
  {
    label: "Contatos",
    value: ContactsLocation,
  },
  {
    label: "Leads",
    value: LeadsLocation,
  },
  {
    label: "Documento",
    value: DocumentDetailsLocation,
  },
  {
    label: "Contato",
    value: ContactDetailsLocation,
  },
  {
    label: "Lead",
    value: LeadDetailsLocation,
  },
  {
    label: "Tabs do Documento",
    value: "",
    selectOptions: [
      {
        label: "Notas",
        value: DocumentDetailsNotesTabLocation,
      },
      {
        label: "Chat",
        value: DocumentDetailsChatTabLocation,
      },
    ],
  },
  {
    label: "Tabs do Contato",
    value: "",
    selectOptions: [
      {
        label: "Notas",
        value: ContactDetailsNotesTabLocation,
      },
      {
        label: "Chat",
        value: ContactDetailsChatTabLocation,
      },
    ],
  },
  {
    label: "Tabs do Lead",
    value: "",
    selectOptions: [
      {
        label: "Notas",
        value: LeadDetailsNotesTabLocation,
      },
      {
        label: "Chat",
        value: LeadDetailsChatTabLocation,
      },
    ],
  },
  {
    label: "Simulação",
    value: SimulationLocation,
  },
];
